import { Button } from 'components/core/Button/Button.styles';
import { Menu } from 'components/GlobalHeader/GlobalHeader.styles';
import styled from 'styled-components';
import {
  handleStatusBackground,
  handleStatusColor,
} from 'components/Table/Table.helper';
import { LoadingSpinner } from 'styles/sharedStyles';

export const TableParent = styled.div`
  overflow-x: auto;
`;

export const TableWrapper = styled.table`
  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 100%;
  }

  border: none;

  table-layout: fixed;

  border-collapse: separate;
  border-spacing: 0 8px;

  & > thead :hover:first-child {
    box-shadow: unset;
  }
`;

export const TableRow = styled.tr`
  animation-timing-function: ease-out;
  animation-duration: 200ms;
  transition: 0.3s;

  &:hover {
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);

    animation-timing-function: ease-out;
    animation-duration: 200ms;

    opacity: 1;
  }

  td,
  th {
    padding-left: 24px;
    background: #ffffff;
  }

  > :first-child {
    border-bottom-left-radius: 4px;
    border-top-left-radius: 4px;
  }
  > :last-child {
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
  }
`;

export const TableHead = styled.th<{ width?: number }>`
  height: 36px;

  font-size: 0.8rem;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
  color: rgba(0, 0, 0, 0.93);

  user-select: none;
  width: ${({ width }) => (width ? `${width}px` : 'auto')};

  & > div.cursor-pointer {
    cursor: pointer;
  }
`;

export const TableCell = styled.td`
  height: 65px;
  min-width: 110px;
  max-width: 300px;
  left: 24px;
  top: 25px;

  word-wrap: break-word;

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
`;

export const TotalCost = styled.div`
  font-weight: 500;
`;

export const Status = styled.span<{ orderStatus: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 24px;
  height: 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  text-align: center;

  & > div {
    padding: 2px 6px;
    border-radius: 24px;
    color: ${props => handleStatusColor(props.orderStatus)};
    background: ${props => handleStatusBackground(props.orderStatus)};
  }
`;

export const LinkText = styled.a`
  color: #209ad6;
`;

export const TableButton = styled(Button)`
  background-color: transparent;
`;

export const TabParent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: end;
  margin: -41px 0 5px 0; // -41px is to remove the gap between the header and the separate tabs component (All Order, Downloads, etc...)
`;

export const TableUtilitiesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const DatePickerParent = styled.div<{ showYearDropdown?: boolean }>`
  display: flex;
  align-items: center;

  position: relative;

  width: 200px;
  height: 20px;
  background: #ffffff;
  border-radius: 4px;

  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  padding: 12px 16px;

  margin-right: 20px;

  border: solid transparent 1px;

  & input,
  .react-datepicker__input-container {
    /* removes all unnecessary built in styles */
    all: unset;

    /* sets necessary styles */
    border: 0;

    /* fix chrome input width issue */
    width: 95%;
  }

  & .react-datepicker__input-container {
    margin-right: 0.5rem;
  }

  & .react-datepicker-popper {
    width: 600px;
  }

  & .react-datepicker__close-icon {
    padding-right: 16px;
  }

  ${({ showYearDropdown }) =>
    showYearDropdown
      ? '& .react-datepicker__header{min-height:70px;display:flex;flex-direction:column;justify-content:space-between}'
      : null};

  & button::after {
    background-color: #008ec2;
  }
`;

export const ExportButtonWrapper = styled(DatePickerParent)`
  justify-content: space-between;

  width: 111px;

  user-select: none;
  cursor: pointer;
`;

export const ExportIconWrapper = styled.div`
  display: flex;
`;

export const ExportDropdownMenu = styled(Menu)`
  width: 165px;
`;

export const LoadingBarWrapper = styled.div`
  width: 100vw;
`;

export const OrderSearchWrapper = styled(DatePickerParent)<{
  isInvalidInput?: boolean;
}>`
  position: relative;
  border: ${({ isInvalidInput }) => isInvalidInput && 'solid red 1px'};
  transition: all 0.2s ease-in-out;

  > input {
    width: 85%;
  }
  &::after {
    content: 'Invalid Order Number';
    opacity: ${({ isInvalidInput }) => (isInvalidInput ? '1' : '0')};
    position: absolute;
    top: -20px;
    color: red;
    font-size: 0.7rem;
    transition: all 0.2s ease-in-out;
  }
`;

export const SearchLoadingSpinnerParent = styled.div`
  > :first-child {
    margin-right: 10px;
    max-width: 30px;
    max-height: 30px;
  }
`;

export const SearchLoadingSpinner = styled(LoadingSpinner)`
  position: relative;
  left: -10px;
`;

export const FilterWrapper = styled.div`
  position: relative;
`;

export const FilterIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 42px;
  height: 42px;

  border: 1px solid rgba(0, 0, 0, 0.495);
  border-radius: 4px;

  cursor: pointer;

  > svg {
    color: rgba(0, 0, 0, 0.495);
  }
`;

export const FilterMenu = styled(Menu)`
  display: flex;
  flex-direction: column;
  gap: 20px;

  width: 460px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.125);

  overflow: hidden;

  position: absolute;
  top: 50px;
  right: 0;

  > * {
    padding: 0 30px;
  }
`;

export const FilterMenuHeader = styled.div<{ $spacer?: boolean }>`
  display: flex;
  justify-content: space-between;

  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;

  ${({ $spacer }) =>
    $spacer && 'border-bottom: 1px solid rgba(0, 0, 0, 0.085);'}
  ${({ $spacer }) => $spacer && 'padding: 20px 30px;'}
`;

export const FilterMenuCloseButton = styled.div`
  cursor: pointer;
`;

export const FilterMenuHeaderClear = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;

  cursor: pointer;
`;

export const FilterBottom = styled.div<{ $spacer?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ $spacer }) => $spacer && 'padding: 20px 30px;'}

  box-shadow: 0px -4px 3px rgba(0, 0, 0, 0.0225);
`;

export const FilterBottomClearAll = styled.div`
  cursor: pointer;
`;

export const FilterStatusWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DownloadIconContainer = styled.div`
  cursor: pointer;
`;
